import type { PostalCodeOption } from '@/composables/usePostalCode';
import type { DriverUpdateEmit } from './types';

const LOCATION_IDS = ['idEstado', 'idCiudad', 'idMunicipio'] as const;

export function usePostalCodeUpdates(emit: DriverUpdateEmit): {
  handleSelect: (item: PostalCodeOption) => void;
  handleClear: () => void;
  handleInvalidate: () => void;
} {
  const clearLocationIds = (): void => {
    LOCATION_IDS.forEach((field) => emit('update', field, undefined));
  };

  const handleSelect = (item: PostalCodeOption): void => {
    emit('update', 'postalCode', item.code);
    emit('update', 'postalCodeDisplay', item.displayValue);
    LOCATION_IDS.forEach((field) => {
      if (item[field] !== undefined) emit('update', field, item[field]);
    });
  };

  const handleClear = (): void => {
    emit('update', 'postalCode', '');
    emit('update', 'postalCodeDisplay', '');
    clearLocationIds();
  };

  const handleInvalidate = (): void => {
    emit('update', 'postalCode', '');
    clearLocationIds();
  };

  return { handleSelect, handleClear, handleInvalidate };
}
